/*eslint no-array-constructor: "off"*/
/*eslint react-hooks/exhaustive-deps: "off"*/
import withValidarRecuperar from 'HOC/withValidarRecuperar';
import { ApiKeyFetch } from 'api/fetchers/apiKey';
import BreadCrumbPasosV2 from 'components/BreadCrumbMex/BreadCrumbPasosV2';
import Page from 'components/Page';
import EmisionFooterBarButtons from 'components/Polizas/EmisionFooterBarButtons';
import FormAseguradoHerederos from 'components/Polizas/FormAseguradoHerederos';
import { ambienteAplicacion } from 'constants/urls';
import { URLS_PHP_7 } from 'constants/urls_v2';
import { useNavbarContext } from 'contexts/NavbarContext';
import useBuscarColonias from 'hooks/useBuscarColonias';
import useBuscarMunicipios from 'hooks/useBuscarMunicipios';
import useCustomForm from 'hooks/useCustomForm';
import moment from 'moment';
import React, { useCallback, useEffect, useState } from 'react';
import { FormProvider } from 'react-hook-form';
import { PASOS_BREADCRUMBS } from 'utils/constants';
import PRODUCTOS from 'utils/constants/PRODUCTOS';
import { isArray, mapArrayDropdownOptions } from 'utils/funciones';
import Loading from 'wrappers/Loading';
import BreadCurmb from '../../components/BreadCrumbMex/BreadCrumb';

const processUnidadDate = (unidad) => {
  if (unidad === 'MM') {
    return 'M';
  }

  if (unidad === 'yyyy') {
    return 'y';
  }

  if (unidad === 'DD') {
    return 'd';
  }
};

const ContainerFormAseguradoHerederos = ({ addWarningToast, qParams, history }) => {
  const methods = useCustomForm({ mode: 'onChange' });
  const [catalogo, setCatalogo] = useState(null);
  const [catalogoListado, setCatalogoListado] = useState(null);
  const [loading, setLoading] = useState(true);
  const { idPoliza, idAsegurado, parentesco, codProducto } = qParams;

  const municipiosHook = useBuscarMunicipios();
  const { setMunicipios, municipios } = municipiosHook;
  const coloniasHook = useBuscarColonias();
  const { setColonias } = coloniasHook;
  const { setProductoActivo } = useNavbarContext();
  const [parametros, setParametros] = useState({
    porcentaje: 100,
    maximoBeneficiarios: 4,
    msgMaximoBeneficiarios: '',
    minimoBeneficiarios: 1,
    magMinimoBeneficiarios: '',
  });

  const init = useCallback(async () => {
    setLoading(true);
    setProductoActivo(codProducto);

    const Data = {
      ambiente: ambienteAplicacion,
      polCodigo: idPoliza,
      prodCodigo: codProducto,
      pasoAsegurado: 'listarAsegurados',
      pasoCatContratante: 'catalogoContratante',
      idAsegurado: idAsegurado || '',
    };

    const res = await ApiKeyFetch.instance().post(URLS_PHP_7.emision.seccionCargaAsegurado, Data);
    console.log('RES: ', res);
    if (res?.transaccion && res?.data) {
      const { colonias, municipios, catalogo, asegurado } = res?.data;

      if (isArray(colonias)) setColonias(colonias?.map(mapArrayDropdownOptions));

      if (isArray(municipios)) setMunicipios(municipios?.map(mapArrayDropdownOptions));

      typeof asegurado === 'object' && methods.reset(asegurado);

      if (!catalogo?.camposAdicionales?.permitirEmitir) {
        addWarningToast('No se puede emitir esta póliza', { autoDismiss: false });
      }

      setCatalogoListado(catalogo);

      const numBeneficiariosvalidacion = catalogo?.objParentesco?.validaciones.find(
        (e) => e.name === 'numBeneficiariosvalidacion'
      );
      const porcentajeBeneficiario = catalogo?.objParentesco?.validaciones.find(
        (e) => e.name === 'porcentajeBeneficiario'
      );
      const { listadoParentezcos } = catalogo.objParentezcos;
      const newParametros = {
        ...parametros,
        parentescos: listadoParentezcos,
      };

      if (numBeneficiariosvalidacion && porcentajeBeneficiario) {
        newParametros.minimoBeneficiarios = numBeneficiariosvalidacion.min.value;
        newParametros.maximoBeneficiarios = numBeneficiariosvalidacion.max.value;
        newParametros.porcentaje = porcentajeBeneficiario.max.value;
      }

      setCatalogo(catalogo);

      setParametros(newParametros);
    }

    setLoading(false);
  }, []);

  useEffect(() => {
    init();
  }, []);

  const processSubmitData = (data) => {
    data.parentezco = parentesco;
    const { parentezcos } = catalogoListado;
    console.log(parentezcos);
    const objParentesco = parentezcos.find((e) => e.value === parentesco);
    data.parentezcoLabel = objParentesco.label;
    console.log('DATA: ', data);
    return data;
  };

  const guardarInformacion = async (data, guardarDatos = true) => {
    data = processSubmitData(data);
    setLoading(true);
    let Data = {
      guardarDatos,
      datosCotizador: {
        prodCodigo: PRODUCTOS.APINDIVIDUAL,
        cotPasoCodigo: 'asegurado',
        polCodigo: idPoliza,
        accion: 'crear',
        idAsegurado: '',
        datosContratanteAsegurado: data,
      },
    };

    if (idAsegurado) {
      Data.datosCotizador.idAsegurado = idAsegurado;
      Data.datosCotizador.accion = 'modificar';
    }

    await ApiKeyFetch.instance().post(URLS_PHP_7.emision.datosEmision, Data);
    history.push(`/emision-asegurados?idPoliza=${idPoliza}&codProducto=${PRODUCTOS.APINDIVIDUAL}`);
    setLoading(false);
  };

  const onSubmit = async (data) => {
    data.estadoIngreso = 'COMPLETADO';
    data.datosCompletos = true;
    console.log('GUARDAR');
    const { parentezcos, validacionesAsegurados } = catalogoListado;
    const objParentesco = parentezcos.find((e) => e.value === parentesco);
    const validacionEdad = validacionesAsegurados[objParentesco.validacion];
    if (validacionEdad && data.fechaNacimiento) {
      if (validacionEdad.min) {
        console.log(validacionEdad);

        const fechaMinima = moment().subtract(
          String(validacionEdad.min.value),
          processUnidadDate(validacionEdad.min.unidad)
        );

        const fechaMinimaAnios = moment().diff(fechaMinima, 'years', true);
        const fechaNacimientoAnios = Math.floor(moment().diff(data.fechaNacimiento, 'years', true));

        if (fechaNacimientoAnios < fechaMinimaAnios) {
          methods.setError('fechaNacimiento', {
            type: 'custom',
            message: validacionEdad.min.message,
          });
          return addWarningToast(validacionEdad.min.message);
        }
      }

      if (validacionEdad.max) {
        const fechaMaxima = moment().subtract(
          String(validacionEdad.max.value),
          processUnidadDate(validacionEdad.max.unidad)
        );

        const fechaMaximaAnios = moment().diff(fechaMaxima, 'years', true);
        const fechaNacimientoAnios = Math.floor(moment().diff(data.fechaNacimiento, 'years', true));
        if (fechaNacimientoAnios > fechaMaximaAnios) {
          methods.setError('fechaNacimiento', {
            type: 'custom',
            message: validacionEdad.max.message,
          });
          return addWarningToast(validacionEdad.max.message);
        }
      }
    }

    await guardarInformacion(data, false);
  };

  const onGuardar = async () => {
    let data = methods.getValues();

    data.estadoIngreso = 'PENDIENTE';
    data.datosCompletos = false;

    const valid = await methods.trigger('tipoPersona');

    if (valid) {
      await guardarInformacion(data, false);
    } else {
      addWarningToast('Debe seleccionar un tipo de persona');
    }
  };

  const onSubmitError = (errors) => {
    console.log(errors);

    addWarningToast('Rellene el formulario correctamente');
  };

  return (
    <Loading loading={loading}>
      <div className="cr-content">
        <Page>
          <BreadCurmb {...PASOS_BREADCRUMBS[codProducto].breadCrumb} />
          <BreadCrumbPasosV2
            {...PASOS_BREADCRUMBS[codProducto].breadCrumbPasosEmision[2]}
            pasos={PASOS_BREADCRUMBS?.[codProducto]?.pasosEmision}
          />
          <FormProvider {...{ ...methods, parametros, onSubmit }}>
            {/* <DevTool control={methods.control} /> */}
            <FormAseguradoHerederos
              catalogo={catalogo}
              municipios={municipios}
              idPoliza={idPoliza}
              onGuardar={onGuardar}
              {...{ ...coloniasHook, ...municipiosHook }}
            />
          </FormProvider>
        </Page>

        <EmisionFooterBarButtons
          onClickAtras={() => {
            history.push(`/emision-asegurados?idPoliza=${idPoliza}&codProducto=${PRODUCTOS.APINDIVIDUAL}`);
          }}
          onClickGuardar={onGuardar}
          onClickContinuar={methods.handleSubmit(onSubmit, onSubmitError)}
        />
      </div>
    </Loading>
  );
};

export default withValidarRecuperar(ContainerFormAseguradoHerederos);
